module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-2-51768c4be7881d864d77d2759b699cce.jpg";